<template>
    <div
        v-if="showPaginate"
        class="flex flex-col lg:flex-row items-center"
        :class="[hideTotals ? 'justify-center' : 'justify-between']"
    >
        <div
            v-if="!hideTotals"
            class="text-black"
            v-html="$t('general.pagination.showing', {from: (currentPage - 1) * itemsPerPage + 1, to: (currentPage * itemsPerPage < totalItems ? currentPage * itemsPerPage : totalItems), total: totalItems})"
        ></div>
        <nav
            aria-label="Pagination"
            class="z-0 inline-flex items-center space-x-6"
        >
            <button
                class="flex items-center cursor-pointer text-black disabled:text-primary-60 disabled:pointer-events-none disabled:cursor-not-allowed"
                @click="handlePaginationClick('prev')"
                :disabled="currentPage === 1"
            >
                <svg-icon type="keyboard-arrow-left" class="w-18 h-18"></svg-icon>
                {{ $t('general.pagination.previous') }}
            </button>
            <div class="flex items-center justify-center gap-18">
                <button
                    v-for="page in pageNumbers"
                    class="text-black"
                    :class="[page === currentPage ? 'font-semibold pointer-events-none' : 'cursor-pointer']"
                    @click="handlePaginationClick(page)"
                    :disabled="isDot(page) || page === currentPage"
                >
                    {{ page }}
                </button>
            </div>
            <button
                class="flex items-center cursor-pointer text-black disabled:text-primary-60 disabled:pointer-events-none disabled:cursor-not-allowed"
                @click="handlePaginationClick('next')"
                :disabled="currentPage === totalPages"
            >
                {{ $t('general.pagination.next') }}
                <svg-icon type="keyboard-arrow-right" class="w-18 h-18"></svg-icon>
            </button>
        </nav>
    </div>
</template>
<script>
import SvgIcon from "../ui/SvgIcon.vue";
export default {
    name: "Pagination",
    components: {
        'svg-icon': SvgIcon,
    },
    props: {
        totalItems: {
            type: Number,
            required: true,
        },
        itemsPerPage: {
            type: Number,
            default: 10,
        },
        dots: {
            type: String,
            default: '...',
        },
        onEachSide: {
            type: Number,
            default: 2,
        },
        keepPagination: Boolean,
        hideTotals: Boolean,
    },
    data() {
        return {
            currentPage: 1,
            totalPages: 0,
        }
    },
    computed: {
        showPaginate() {
            return this.totalPages === 1 ? this.keepPagination : true;
        },
        pages() {
            const pages = [];
            for (let i = 1; i <= this.totalPages; i++) {
                pages.push(i);
            }
            return pages;
        },
        pageNumbers() {
            let pages = [];
            for (let i = 1; i <= this.totalPages; i++) {
                if (i === 1 || i === this.totalPages || (i >= this.currentPage - this.onEachSide && i <= this.currentPage + this.onEachSide)) {
                    pages.push(i);
                } else if (pages[pages.length - 1] !== this.dots) {
                    pages.push(this.dots);
                }
            }
            return pages;
        }
    },
    methods: {
        isDot(page) {
            return page === this.dots;
        },
        handlePaginationClick(page) {
            if (page === 'prev') {
                this.currentPage--;
                this.$emit('prev');
            } else if (page === 'next') {
                this.currentPage++;
                this.$emit('next');
            } else {
                this.currentPage = page;
                this.$emit('go-to', page - 1);
            }
        }
    },
    beforeMount() {
        this.totalPages = Math.ceil(this.totalItems / this.itemsPerPage);
    }
}
</script>
<style scoped>

</style>